











import { Component, Vue } from 'vue-property-decorator';
import ManufacturerFilter from './filterComponents/ManufacturerFilter.vue';
import CompanyFilter from './filterComponents/CompanyFilter.vue';
import ItemTypeFilter from './filterComponents/ItemTypeFilter.vue';
import CategoryFilter from './filterComponents/CategoryFilter.vue';
import ImageComponent from './ImageComponent.vue';
import AttributeFilter from './filterComponents/AttributeFilter.vue';
import { Action, Mutation, Getter } from 'vuex-class';

@Component({
  components: {
    ManufacturerFilter,
    AttributeFilter,
    CompanyFilter,
    ItemTypeFilter,
    CategoryFilter,
    ImageComponent,
  },
})
export default class SearchFilter extends Vue {
  @Getter public hasAnyFilter!: boolean;
  @Mutation private uncheckCheckedFilters!: () => void;
  @Action private fetchItems: any;

  public resetFilters() {
    this.uncheckCheckedFilters();
    this.fetchItems({ generateFilters: true });
  }
}
